<script>
  import pdf from 'vue-pdf'
  
  // display both resume pages
  var loadingTask = pdf.createLoadingTask('./resume.pdf');

  export default {
    components: {
      pdf
    },
    data() {
		return {
			src: loadingTask,
			numPages: undefined,
		}
	},
	mounted() {
		this.src.promise.then(pdf => {
			this.numPages = pdf.numPages;
		});
	}
  }
</script>
<template>
  <div class="resume">
    <h1>My Resume<br/>
      <a href="resume.pdf" download="Andy Riecker Resume">
        <button class="button is-info" type="button">Download</button> 
      </a> 
    </h1>
    <pdf v-for="i in numPages"
			:key="i"
			:src="src"
			:page="i"
			style="display: inline-block; width: 50%; height: 100%;"
      class='iframe'>
    </pdf>
    <!-- <iframe src="https://docs.google.com/gview?url=https://github.com/tuftsanti/resume/raw/master/resume.pdf&embedded=true" style="width:100%; height:100%;" frameborder="0"></iframe> -->
    <!-- <iframe src="../../public/resume.pdf" width="100%" height="100%"></iframe> -->
  </div>
</template>
<style scoped>
  iframe {
    width: 100%;
    height: 100%;
  }
  @media (max-width: 500px) {
    iframe {
      width: 50%;
      height: 50%;
    }
  }
  .resume {
    width: 100%;
    /* height: 100vh; */
    margin: 0;
  }
  h1 {
  background-color: ghostwhite;
  padding: 10px;
  color: #2c3e50;
  font-weight: bold;
  }
</style>
